import { render, staticRenderFns } from "./message-single.vue?vue&type=template&id=22cbd72e&"
import script from "./message-single.vue?vue&type=script&lang=ts&"
export * from "./message-single.vue?vue&type=script&lang=ts&"
import style0 from "./message-single.vue?vue&type=style&index=0&lang=scss&_scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports